export default __webpack_public_path__ + "static/phoneCall02-5c734293aca3307c57da8e3ec1513ef9.webp";